export enum NotificationTypeEnum {
    SUCCESS = 1,
    ERROR = 2,
}
